import {SideNavigationRepo} from './SideNavigationRepo'
import SIDE_MENU_LIST from '../DTO/SideMenuList.json'

export class NetworkSideNavigationRepo implements SideNavigationRepo {
  getMenuList(): { [key: string]: boolean } {
    return SIDE_MENU_LIST
  }
}
